var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loggedInStatus)?_c('Login',{on:{"statusChange":_vm.statusChange}}):_c('Statistics',{attrs:{"dataUser":_vm.loggedInUserData,"dataQuestions":_vm.questions},on:{"logout":_vm.logout}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }